import { Component, EventBus } from '../core/smpl-components.js'
import { Events } from '../core/events'

// Global analytics bridge. SEOmatic injects gtag in the <head>, which auto-sends
// a page_view on the initial full load only. Swup swaps content without a reload,
// so we forward each subsequent navigation as a GA4 page_view here.
//
// Deliberately small: one place to hang future tracking (events, other providers)
// off the same Swup lifecycle without touching individual components.
export default class extends Component {
	prepare() {
		this.bndOnPageView = this.onPageView.bind(this)
		EventBus.on(Events.SWUP_PAGE_VIEW, this.bndOnPageView)
	}

	mount() {}

	unmount() {
		EventBus.off(Events.SWUP_PAGE_VIEW, this.bndOnPageView)
	}

	// Fires after Swup has swapped the DOM and updated the URL + title, so
	// window.location and document.title already reflect the new page.
	onPageView() {
		if (typeof window.gtag !== 'function') return

		window.gtag('event', 'page_view', {
			page_title: document.title,
			page_location: window.location.href,
			page_path: window.location.pathname + window.location.search,
		})
	}
}
